<template>
  <q-page>
    <transition :name="slideDirection" mode="out-in">
      <component :is="currentView" :transName="slideDirection" ref="editor">
      </component>
    </transition>
  </q-page>
</template>
<style scoped>

</style>
<script type="text/babel">
import store from '../store';
// import CaseEdit from 'components/case-edit.vue';
import DivisionEdit from 'components/division-edit.vue';
import HospitalEdit from 'components/hospital-edit.vue';
import InstrumentEdit from 'components/instrument-edit.vue';
import PersonEdit from 'components/person-edit.vue';

export default {
  name: 'switchnew',
  components: {
    // CaseEdit,
    DivisionEdit,
    HospitalEdit,
    InstrumentEdit,
    PersonEdit,
  },
  data() {
    return {
      slideDirection: 'slide-r',
    };
  },
  beforeRouteEnter(to, from, next) {
    if (store.getters.isReader) {
      store.commit('pushError', {
        error: 'Не разрешено!',
        message: 'Доступ к редактированию запрещен. Недостаточно прав',
      });
      next('/list');
    } else if (to.params.type === 'h') { // not require parent_id
      next();
    } else if (to.params.parent_id) { // TODO cases?
      next();
    } else {
      next('/list');
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.editor && !this.$refs.editor.notChanged) {
      this.$q.dialog({
        title: 'Внимание',
        'prevent-close': true,
        message: 'При переходе изменения не будут сохранены!',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Перейти',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Остаться',
        },
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  computed: {
    currentView() {
      if (this.$route.params.type === 'c') return 'CaseEdit';
      else if (this.$route.params.type === 'd') return 'DivisionEdit';
      else if (this.$route.params.type === 'h') return 'HospitalEdit';
      else if (this.$route.params.type === 'i') return 'InstrumentEdit';
      else if (this.$route.params.type === 'p') return 'PersonEdit';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/switch-new.vue